/**
 * Feature flags the API reports for the WebUI (GET /api/users/me/features). With a flag off its
 * section's API routes do not exist, so the section stays hidden whatever the user's permissions.
 */
export interface Features {
  amsBooking: boolean
  /** The availability page's dated week view (AMS M12). */
  amsAvailabilityWeekView: boolean
  /** One site per host per slot is enforced on host-availability saves (AMS M12). */
  amsHostSiteExclusivity: boolean
}

export type FeatureName = keyof Features

/** Everything off: what the UI assumes until the API says otherwise, or if it cannot say. */
export const NO_FEATURES: Features = { amsBooking: false, amsAvailabilityWeekView: false, amsHostSiteExclusivity: false }
